import { createStylesheet } from "@shared/utils/elements";
import { config } from "./services/config";
import * as tickets from "./features/tickets";
import styles from "./sdk.css";

declare global {
  interface Window {
    showpass: typeof showpass;
  }
}

const showpass = {
  config,
  tickets,
};

// Inject SDK stylesheet to page
const { head } = document;
const stylesheet = createStylesheet(styles as string);
head.appendChild(stylesheet);

// Expose SDK to window
window.showpass = showpass;
